// 종목별 프론트 설정 표.
// 코트 배경 SVG처럼 "그림 자산 / 화면 표현"에 해당하는 것은 서버가 아니라 여기(프론트)에서 관리한다.
// 새 종목 추가 = 이 표에 그 종목 항목을 추가하면 됨(컴포넌트는 안 건드림).

const DEFAULT_COURT_SVG = "/images/verticalGround.svg"

const SPORT_COURT_SVG: Record<string, string> = {
  Football: "/images/verticalGround.svg",
  Volleyball: "/images/volleyballCourt.svg",
  // 럭비는 15인제/7인제 모두 동일 코트 이미지
  Rugby15: "/images/rugbyCourt.svg",
  Rugby7: "/images/rugbyCourt.svg",
}

// 종목에 맞는 코트 배경 SVG 경로. 미등록 종목은 기본(축구)로 폴백.
export const getCourtSvg = (sportType?: string): string =>
  (sportType && SPORT_COURT_SVG[sportType]) || DEFAULT_COURT_SVG

// 코트 SVG(348×540 캔버스) 안에서 실제 "경기장 영역"이 차지하는 비율(0~1).
// 맵 컴포넌트는 선수/거리 계산을 이미지 전체가 아니라 이 영역 기준으로 한다.
// (예: 럭비는 세로 고정+진짜 비율 유지로 가로가 좁게 그려져 좌우에 여백이 있음)
export type CourtField = { left: number; top: number; right: number; bottom: number }

const DEFAULT_COURT_FIELD: CourtField = { left: 0, top: 0, right: 1, bottom: 1 }

// 럭비 코트(rugbyCourt.svg): 경기장 사각형이 가로 17~331 / 348 에 그려짐(세로는 full).
const RUGBY_COURT_FIELD: CourtField = { left: 17 / 348, top: 0, right: 331 / 348, bottom: 1 }

const SPORT_COURT_FIELD: Record<string, CourtField> = {
  Rugby15: RUGBY_COURT_FIELD,
  Rugby7: RUGBY_COURT_FIELD,
}

// 종목 코트의 경기장 영역(비율). 미등록 종목은 full-bleed(경기장=이미지 전체).
export const getCourtField = (sportType?: string): CourtField =>
  (sportType && SPORT_COURT_FIELD[sportType]) || DEFAULT_COURT_FIELD

// 럭비 종목(15인제/7인제) 집합. 럭비 전용 표현 분기에 공통으로 쓴다.
const RUGBY_SPORTS = new Set<string>(["Rugby15", "Rugby7"])

// 포메이션 맵의 거리 측정선·수치 표기 노출 여부. 럭비는 숨김, 그 외/미등록은 표시(기존 동작).
export const showFormationMeasurements = (sportType?: string): boolean =>
  !sportType || !RUGBY_SPORTS.has(sportType)

// 주손(hand) 입력 노출 여부. 럭비만 주발+주손, 그 외는 주발만.
export const showDominantHand = (sportType?: string): boolean =>
  !!sportType && RUGBY_SPORTS.has(sportType)

// 종목 화면 표시명. 럭비15/7은 둘 다 "Rugby"로 표기.
const SPORT_LABEL: Record<string, string> = {
  Football: "Football",
  Volleyball: "Volleyball",
  Rugby15: "Rugby",
  Rugby7: "Rugby",
}

// 종목 표시명. 미등록 종목은 원문 그대로, undefined는 빈 값(표시 숨김).
export const getSportLabel = (sportType?: string): string =>
  (sportType && (SPORT_LABEL[sportType] ?? sportType)) || ""
